import {
  LinkBox,
  Text,
  LinkOverlay,
  Box,
  Image,
  VStack,
  AspectRatio,
} from '@chakra-ui/react'

import { Link } from '@/lib/Link'
import { logEvent } from '@/lib/stats/gtm'

interface Props {
  href: string
  title: string
  description: string
  image: string
  gradient: string
}

function ImageLink({
  href,
  title,
  description,
  image,
  gradient,
}: Props): React.ReactElement {
  return (
    <LinkBox as="article">
      <AspectRatio
        ratio={352 / 295}
        sx={{
          maxW: '100%',
          w: {
            base: '288px',
            md: '260px',
          },
        }}
      >
        <Box
          sx={{
            h: 'full',
            w: 'full',
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '10px',
            '& > *': {
              borderRadius: 'inherit',
              overflow: 'hidden',
            },
          }}
        >
          <Box
            sx={{
              position: 'relative',
              zIndex: 2,
              h: 'full',
              w: 'full',
              color: 'white',
              fontWeight: 'light',
              backgroundImage: `${gradient}`,
              '& + * > img': {
                transform: 'scale(1)',
              },
              '&:hover + * > img': {
                transform: 'scale(1.1)',
              },
            }}
          >
            <VStack
              sx={{
                position: 'relative',
                h: '70%',
                w: 'full',
                mt: 'auto',
                p: 6,
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                color: 'white',
                fontWeight: 'light',
              }}
            >
              <Text
                as="h1"
                sx={{
                  fontSize: 'xl',
                  fontWeight: 'medium',
                }}
              >
                {title}
              </Text>
              <Text>{description}</Text>
              <Text>
                <Link route={href} passHref>
                  <LinkOverlay
                    sx={{
                      color: 'inherit',
                      textDecoration: 'underline',
                      fontWeight: 'medium',
                      transition: 'opacity 500ms',
                      '&:hover': {
                        opacity: 0.8,
                      },
                    }}
                    onClick={() => {
                      logEvent({
                        ga: {
                          category: 'Policy Demo',
                          action: 'Other Policies',
                          label: title,
                        },
                      })
                    }}
                  >
                    ดูข้อมูลเพิ่มเติม
                  </LinkOverlay>
                </Link>
              </Text>
            </VStack>
          </Box>
          <Box
            sx={{
              position: 'absolute',
              zIndex: 1,
              top: 0,
              left: 0,
              w: 'full',
              h: 'full',
            }}
          >
            <Image
              src={image}
              alt="Service Link Image"
              sx={{
                w: 'full',
                h: 'full',
                transition: 'transform 500ms',
                objectFit: 'cover',
              }}
            />
          </Box>
        </Box>
      </AspectRatio>
    </LinkBox>
  )
}
export default ImageLink
